import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { UserService } from '../../services/user-service/user.service';

@Component({
    selector: 'app-account-settings',
    standalone: true,
    imports: [RouterLink, MatButtonModule, MatInputModule, MatFormFieldModule, MatSelectModule, FileUploadModule],
    templateUrl: './account-settings.component.html',
    styleUrl: './account-settings.component.scss'
})
export class AccountSettingsComponent {

    // Select Value
    genderSelected = 'option1';

    // File Uploader
    public multiple: boolean = false;

    // isToggled
    isToggled = false;

    constructor(
        private userService:UserService,
        public themeService: CustomizerSettingsService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }
    user: any = {}; // Stockera les données de l'utilisateur
    
        ngOnInit(): void {
            console.log("User ID from session:", sessionStorage.getItem('user_id'));
            this.loadUser();
          }
          
          loadUser() {
            const userId = sessionStorage.getItem('user_id');
        
            if (userId) {
              const numericUserId = parseInt(userId, 10);
        
              if (!isNaN(numericUserId)) {
                console.log("Fetching user with ID:", numericUserId);
        
                this.userService.getUserById(numericUserId).subscribe({
                  next: (userData) => { // userData est maintenant un `AppUserDTO`
                    console.log("User data received:", userData);
                    this.user = userData; // Pas besoin d'accéder à `.data`, car c'est déjà extrait
                  },
                  error: (err) => {
                    console.error("Erreur lors de la récupération de l'utilisateur :", err);
                  }
                });
              } else {
                console.error("L'ID utilisateur n'est pas valide.");
              }
            } else {
              console.error("Aucun ID utilisateur trouvé en session.");
            }
        }
        
          
        
        // Méthode pour mapper les rôles en labels plus lisibles
        mapRole(role: string | null): string {
            if (!role) return 'Utilisateur'; // Valeur par défaut
            const roleMappings: { [key: string]: string } = {
                'ROLE_ROLE_ADMIN': 'Administrateur',
                'ROLE_ROLE_WORKER': 'Worker',
                'ROLE_ROLE_USER': 'Utilisateur',
                'ROLE_ROLE_MANAGER': 'Manager',
            };
            return roleMappings[role] || 'Utilisateur'; // Si le rôle est inconnu, afficher "Utilisateur"
        }
    }
    
